export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7907.d5b06db3.jpg";